export default function initPopinContactForm() {
    if (document.querySelector('.popins-form-contact')) {
        new PopinContactForm(document.querySelector('.popins-form-contact'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class PopinContactForm {
    constructor($el) {
        this.$el = $el;
        this.$btnsContactReferent = document.querySelectorAll('.js-btn-contact-form');
        this.$popinsContactForm = document.querySelectorAll('.js-popin-form-contact');
        this.$btnsClosePopinContactForm = document.querySelectorAll('.js-btn-close-popin-form');
        this.init();
    }

    init() {
        let currentPopinReferent = false;
        
        this.$btnsContactReferent.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                const referent = evt.target.dataset.referent;

                this.$popinsContactForm.forEach(popin => {
                    if (popin.dataset.referent === referent) {
                        document.querySelector('body').classList.add('noscroll');
                        popin.classList.add('visible');
                        currentPopinReferent = popin;
                    }
                });
            });
        });

        this.$btnsClosePopinContactForm.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                currentPopinReferent.classList.remove('visible');
                document.querySelector('body').classList.remove('noscroll');
                currentPopinReferent = false;
            });
        });
    }
}
